import { PropsWithChildren } from "react"

export function ToolBar({ children }: PropsWithChildren<{}>) {
  return <div className="mb-2 toolbar">{children}</div>
}
